import { Input } from "reactstrap";
import { LI, UL } from "../../../../../../../AbstractElements";
import { VariationBoxData } from "../../../../../../../Data/Forms&Table/Forms/FormLayout";

const VariationBox = () => {
  return (
    <div className="variation-box">
      {VariationBoxData.map((data, index) => (
        <div className="selection-box" key={index}>
          <Input type="checkbox" />
          <div className="custom--mega-checkbox">
            <UL className="d-flex flex-column align-items-center simple-list">
              <LI>{data.title}</LI>
              <LI className="txt-primary">{data.details}</LI>
            </UL>
          </div>
        </div>
      ))}
    </div>
  );
};
export default VariationBox;
